import { Injectable } from '@angular/core';

type LandingPageOption = {
  route: string;
  labelKey: string;
  icon: string;
};

const STORAGE_KEY = 'userPrefs.landingPage';
const DEFAULT_LANDING = '/dashboard';

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  readonly landingPageOptions: LandingPageOption[] = [
    { route: '/dashboard', labelKey: 'USER_PREFS.LANDING.DASHBOARD', icon: 'dashboard' },
    { route: '/matters', labelKey: 'USER_PREFS.LANDING.CASES', icon: 'gavel' },
    { route: '/work-requests', labelKey: 'USER_PREFS.LANDING.WORK_REQUESTS', icon: 'assignment' },
    { route: '/matters/calendar', labelKey: 'USER_PREFS.LANDING.CALENDAR', icon: 'calendar_month' },
    { route: '/tasks', labelKey: 'USER_PREFS.LANDING.TASKS', icon: 'checklist' },
    { route: '/drafts', labelKey: 'USER_PREFS.LANDING.DRAFTS', icon: 'description' },
  ];

  getLandingPage(): string {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_LANDING;
    } catch {
      return DEFAULT_LANDING;
    }
  }

  setLandingPage(route: string): void {
    const valid = this.landingPageOptions.some((opt) => opt.route === route);
    if (!valid) return;
    try {
      localStorage.setItem(STORAGE_KEY, route);
    } catch {
      // localStorage unavailable — fail silently
    }
  }

  clearLandingPage(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }

  isCustomLandingSet(): boolean {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return Boolean(stored && stored !== DEFAULT_LANDING);
    } catch {
      return false;
    }
  }
}
